export const CHECKOUT_STEPS_NAMES = {
	planSelection: "plan",
	aboutYou: "about-you",
	setup: "setup",
	proofOfId: "proof-of-id",
	paymentDetails: "payment-details",
};

export const PRODUCT_NAME = {
	mobile: "mobile",
	orderSIM: "ordersim",
	orderESIM: "orderesim",
	authenticatedOrderSIM : "authenticated-order-sim",
	authenticatedOrdereSIM : "authenticated-order-esim",
	energy: "energy",
	internet: "internet",
};

export const SIM_TYPE = {
	eSim: "eSim",
	physicalSim: "physicalSim"
};
export const PRODUCT_OFFER = {
	mobile: "mobile",
	internet: "broadband",
};

export const PAYMENT_TYPE = {
	otehr: "other",
	debitCard: "debit-card",
	creditCard: "credit-card",
};

export const MOBILE_OBJ = {
	type: {
		dss: "TODO",
	},
	characterstic: {
		charDesc: {
			// TODO
		},
	},
	plan: {
		view: {
			base: "base",
		},
	},
};
